import styled from 'styled-components';

const StyledContentGrid = styled.div`
  padding: 2rem 0;
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  width: 100%;
  column-gap: 2rem;
  border-bottom: 1px solid ${(props) => props.theme.color.borderColor};

  @media (max-width: 1024px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const StyledImageContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.5rem;
  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;

const StyledRoomInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1rem;
  font-weight: 600;

  span {
    font-size: 1.25rem;
    font-weight: 700;
  }
`;

const StyledTitleHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

const StyledFacilitiesFlexbox = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
`;

const StyledFlexRow = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export {
  StyledContentGrid,
  StyledImageContainer,
  StyledRoomInfo,
  StyledTitleHeader,
  StyledFacilitiesFlexbox,
  StyledFlexRow,
};
